import React from 'react'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import { Chip } from '../Goals/Goals.styled'

export const GoalCompletionChip = ({
  iconColorStyles,
}: {
  iconColorStyles: Record<string, unknown>
}) => (
  <Chip variant='completed'>
    <CheckCircleOutlineOutlinedIcon sx={iconColorStyles} />
    Completed
  </Chip>
)
